export default __webpack_public_path__ + "static/media/detail_mobile_4_1.0a74705d.png";